import endpoints from "config/endpoints";
import { useMemo } from "react";
import useAxiosRequest from "./common/useAxiosRequest";

const useUfs = () => {
  const { data, loading, error } = useAxiosRequest({
    url: endpoints.ufs(),
    method: "GET",
    autoRun: true,
  });

  const ufs = useMemo(
    () =>
      data?.map(({ codigo }) => ({
        id: codigo,
        value: codigo,
      })),
    [data]
  );

  return { ufs, loading, error };
};

export default useUfs;
